'use strict';

var _ = require('lodash');
var GridToolbarConfigurationMarketAssignController = function GridToolbarConfigurationMarketAssignController($scope) {
  $scope.saveChanges = function () {
    var rows = _.chain($scope.jqxGridSettings.source.loadedData).filter('_old').clone(true).value(true);
    $scope.$emit('configuration-market-assign:saveChanges', rows);
  };
  $scope.$on('configuration-market-assign:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
};
GridToolbarConfigurationMarketAssignController.$inject = ['$scope'];
module.exports = GridToolbarConfigurationMarketAssignController;